import { Button } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback, useState } from 'react';

import { shouldShowNewHomePage } from '../../../util/isNewHomePage';
import { EndLiveChatModal } from '../EndLiveChatModal';
import { headerFullPageDataHooks } from '../HeaderFullPage/HeaderFullPage.dataHooks';

export type EndLiveChatButtonProps = {
  isMobileView?: boolean;
};

export const EndLiveChatButton: FC<EndLiveChatButtonProps> = ({ isMobileView }) => {
  const { t } = useTranslation();
  const [isModalOpened, setModalOpened] = useState(false);

  const onCloseModal = useCallback(() => setModalOpened(false), []);
  const onOpenModal = useCallback(() => setModalOpened(true), []);
  const isNewHomePage = shouldShowNewHomePage();
  return (
    <>
      <EndLiveChatModal isOpen={isModalOpened} onCloseModal={onCloseModal} isMobileView={isMobileView} />
      <Button
        skin="transparent"
        onClick={onOpenModal}
        dataHook={headerFullPageDataHooks.endLiveChat()}
        size={isNewHomePage ? 'small' : 'medium'}
      >
        {t('live_chat_close_btn')}
      </Button>
    </>
  );
};
